import type ViewSettingsDialogCustomTab from "./ViewSettingsDialogCustomTab.js";

export default function ViewSettingsDialogCustomTabTemplate(this: ViewSettingsDialogCustomTab) {
	return <slot></slot>;
}
